export const actionTypes = {
  //Meeting
  UPDATE_MEETING_ID: "UPDATE_MEETING_ID",
  UPDATE_FETCH_TRANS_ID: "UPDATE_FETCH_TRANS_ID",
  UPDATE_MEETING_OPEN: "UPDATE_MEETING_OPEN",
  UPDATE_MEETING_TABLE_DATA: "UPDATE_MEETING_TABLE_DATA",
  UPDATE_SELECTED_ROW_TABLE_DATA: "UPDATE_SELECTED_ROW_TABLE_DATA",
  UPDATE_MEETING_FORM_TYPE: "UPDATE_MEETING_FORM_TYPE",
  UPDATE_MEETING_FORM_LOADING: "UPDATE_MEETING_FORM_LOADING",

  //Intervention labels
  OPEN_INTERVENTION_FORM: "OPEN_INTERVENTION_FORM",
  UPDATE_INTERVENTION_TABLE_DATA: "UPDATE_INTERVENTION_TABLE_DATA",
  DELETE_INTERVENTION_TABLE_DATA: "DELETE_INTERVENTION_TABLE_DATA",
  SELECTED_INTERVENTION_TABLE_ROW: "SELECTED_INTERVENTION_TABLE_ROW",
  UPDATE_FETCH_INTERVENTION_LABEL: "UPDATE_FETCH_INTERVENTION_LABEL",

  UPDATE_INTERVENTION_FORM_TYPE: "UPDATE_INTERVENTION_FORM_TYPE",
  
  //Acronyms/Terminology
  OPEN_ACRONYM_FORM: "OPEN_ACRONYM_FORM",
  UPDATE_ACRONYM_TABLE_DATA: "UPDATE_ACRONYM_TABLE_DATA",
  SELECTED_ACRONYM_TABLE_ROW: "SELECTED_ACRONYM_TABLE_ROW",
  UPDATE_FETCH_ACRONYM: "UPDATE_FETCH_ACRONYM",
  UPDATE_ACRONYM_FORM_TYPE: "UPDATE_ACRONYM_FORM_TYPE",
  
  //Loader
  UPDATE_LOADER_STATE: "UPDATE_LOADER_STATE",

  //User Details permission
  UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",
  UPDATE_USER_PERMISSION: "UPDATE_USER_PERMISSION",

  //User Management
  UPDATE_USER_FORM_OPEN: "UPDATE_USER_FORM_OPEN",
  UPDATE_USER_FORM_TYPE: "UPDATE_USER_FORM_TYPE",
  UPDATE_SELECTED_USER_DATA: "UPDATE_SELECTED_USER_DATA",
  UPDATE_USER_TABLE_DATA: "UPDATE_USER_TABLE_DATA",
};
